module.exports = __webpack_public_path__ + "bin/8ed8a03c20735bf804c78529669da6ee.png";